import { DateWithTimezones } from '../../common/models/status-history-chain.model';

export interface ShipmentTransitTime {
  arrivalDeviation: string;
  departureDeviation: string;
  arrival: DateWithTimezones;
  departure: DateWithTimezones;
  total: string;
  totalDeviation: string;
}

export interface ShipmentTransportOrderTransitTime {
  arrivalDeviation: string;
  departureDeviation: string;
  arrival: DateWithTimezones;
  departure: DateWithTimezones;
  total: string;
  totalDeviation: string;
}
